export const transformServices = (
  partnerServices: string[],
  partnerAdditionalServices: string[],
  partnerServiceLabelsMap: Map<string, string>,
): string[] => {
  const relevantServices: string[] = [...partnerServiceLabelsMap.keys()];

  let services = partnerServices
    .filter((value: string) => relevantServices.includes(value))
    .map((service: string) => partnerServiceLabelsMap.get(service))
    .filter((label: string | undefined): label is string => !!label && label.trim() !== '');

  if (partnerAdditionalServices?.length > 0) {
    const additionalServices = [...partnerAdditionalServices];

    services = [...services, ...additionalServices];
  }

  return services;
};
